import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { progressiveBackground } from '@r1-frontend/ui-react/components/helpers/image';
// @ts-ignore
import Carousel from '@r1-frontend/ui-react/deprecated/carousel';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BreakPointsMFirst } from '~/src/constants/breakpoints';

export const TagText = styled.span`
    width: 100%;
    white-space: normal;
`;

export const StationImg = styled.span<{imgUrl: string, imgWebpUrl?: string}>`
    width: 73px;
    height: 56px;
    ${({ imgUrl, imgWebpUrl }) => progressiveBackground({
        src: imgUrl,
        webpSrc: imgWebpUrl,
    })};
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    @media (max-width: ${breakPoints.desktop}) {
        width: 56px;
    }
`;

export const CarouselWrapperTablet = styled(Carousel)`
    margin-top: 54px;

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-top: 64px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        margin-top: 32px;
    }
`;

export const StationTag = styled.a<{text: string}>`
    display: inline-flex;
    height: 88px;
    width: calc(100% - 23px);
    padding: 16px 22px 16px 30px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    align-items: center;
    gap: 26px;
    flex-basis: calc(25% - 24px);
    cursor: pointer;
    text-decoration: none;
    outline: none;
    background-color: ${COLORS.white};
    color: ${COLORS.black};
    ${FONTS.H4};

    @media (max-width: ${breakPoints.desktop}) {
        padding: 16px 11px 16px 15px;
        gap: 22px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        height: 77px;
        padding: 14px 10px 20px 8px;
        gap: 8px;
        ${FONTS.H5};
    }

    @media (min-width: ${BreakPointsMFirst.mobile}) and (max-width: ${breakPoints.tablet}) {
        height: 88px;
        padding: 16px 45px 16px 30px;
        ${FONTS.H4};
        gap: 32px;
    }

    &:hover {
        box-shadow: 0 4px 24px rgba(0, 0, 0, .08);
    }

    &:active {
        box-shadow: 0 1px 8px rgba(0, 0, 0, .08);
    }
`;
